<template>
  <div class="storeListDiv">
    <div class="cont1">
      <div v-if="isWarehouseman" style="flex: 1;">
        <div
          :class="isActive === 'queuing' ? 'blk cont1-blk1' : 'blk cont1-blk2'"
          @click="changeBtn('queuing')"
        >
          排队中<br />
          <span style="font-size: 16px;">{{ queuingList.length }}</span>
        </div>
      </div>
      <div style="flex: 1;">
        <div
          :class="isActive === 'calling' ? 'blk cont1-blk1' : 'blk cont1-blk2'"
          @click="changeBtn('calling')"
        >
          叫号中<br />
          <span style="font-size: 16px;">{{ callingList.length }}</span>
        </div>
      </div>
      <div style="flex: 1;">
        <div
          :class="isActive === 'loading' ? 'blk cont1-blk1' : 'blk cont1-blk2'"
          @click="changeBtn('loading')"
        >
          装货中<br />
          <span style="font-size: 16px;">{{ loadingList.length }}</span>
        </div>
      </div>
    </div>

    <div style="height: 88px;"></div>
    <van-tabs
      v-model="lineListActive"
      v-if="lineList.length > 1"
      sticky
      @change="changeTab"
    >
      <van-tab :title="item.name" v-for="item in lineList" :key="item.id">
      </van-tab>
    </van-tabs>
    <!-- 排队中 -->
    <div class="cont2" v-if="isActive === 'queuing'">
      <div
        class="cont2-left defaultBg"
        v-for="(item, index) in queuingList"
        :key="index"
      >
        <div class="cont2-left-blk">
          <div class="top">{{ item.code }}</div>
          <div class="image">
            <!-- 不同车的类型不一致 车辆类型（1平板车；2货柜车；3槽罐车；4其他；5高栏车）-->
            <!-- 平板车 -->
            <img
              src="../assets/img/flat.png"
              alt=""
              width="70px"
              v-if="item.report_info.vehicle_type === 1"
            />
            <!-- 货柜车 -->
            <img
              src="../assets/img/truck.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 2"
            />
            <!-- 高栏车 -->
            <img
              src="../assets/img/gaolan.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 5"
            />
            <img src="../assets/img/else_icon.png" v-else alt="" width="70px" />
          </div>
          <div v-if="item.work_state == 2" class="bottom">正在作业中</div>
        </div>
        <div class="cont2-right">
          <span class="right1">{{ item.report_info.license_plate }}</span>
          <span class="right2"
            >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
          ><br />
          单位：{{ item.report_info.unit }}<br />
          进厂时间：{{ formatTime(item.into_factory_time) }}<br />
          手机号码：<span class="colorBlue">{{ item.report_info.contact }}</span
          ><br />
          <span
            v-if="formatStatus(item.into_factory_time, item.booking_time) == 0"
            class="colorBlueLight"
            >提前到厂</span
          >
          <span
            v-if="formatStatus(item.into_factory_time, item.booking_time) == 1"
            class="colorGreenDark"
            >准时到场</span
          >
          <span
            v-if="formatStatus(item.into_factory_time, item.booking_time) == 2"
            class="colorPink"
            >迟到到厂</span
          >
          <span class="right5">已等待：{{ timeCacl(item.create_time) }}</span>
        </div>
      </div>
      <Empty v-if="queuingList.length == 0"></Empty>
    </div>

    <!-- 叫号中 -->
    <div class="cont3" v-if="isActive === 'calling'">
      <div class="cont3-title">正在叫号：</div>
      <div
        class="defaultBg mgBottom10"
        v-for="(item, index) in callingList"
        :key="index"
        style="display: flex;"
      >
        <div class="cont3-left">
          <div class="top">{{ item.code }}</div>
          <div style="padding: 0px 10px;">
            <span class="left1">{{ item.report_info.license_plate }}</span>
            <span class="left2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            ><br />
            装货位置：
            <span class="colorGreenDark"
              >{{ item.warehouse.store_name }}
              {{ item.warehouse.warehouse_name }}</span
            ><br />
            单位：{{ item.report_info.unit }}<br />
            手机号码：<span class="colorBlue">{{
              item.report_info.contact
            }}</span
            ><br />
            已叫号：<span class="colorGreenDark">{{
              timeCacl(item.call_number_time)
            }}</span
            ><br />
            仓管员：{{ item.warehouseman }}
          </div>
        </div>
        <div class="cont3-right">
          <div>
            <van-button
              type="primary"
              class="btn"
              @click="handle('confirmArrival', item)"
              v-if="
                privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
              "
              >确认到达</van-button
            >
          </div>
        </div>
      </div>
      <Empty v-if="callingList.length == 0"></Empty>
    </div>
    <div class="cont3" v-if="isActive === 'calling'">
      <div class="cont3-title">已过号(超过35分钟)：</div>
      <div
        class="defaultBg mgBottom10"
        v-for="(item, index) in callingPassList"
        :key="index"
        style="display: flex;"
      >
        <div class="cont3-left">
          <div class="top">{{ item.code }}</div>
          <div style="padding: 0px 10px;">
            <span class="left1">{{ item.report_info.license_plate }}</span>
            <span class="left2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            ><br />
            装货位置：
            <span class="colorGreenDark"
              >{{ item.warehouse.store_name }}
              {{ item.warehouse.warehouse_name }}</span
            ><br />
            单位：{{ item.report_info.unit }}<br />
            手机号码：<span class="colorBlue">{{
              item.report_info.contact
            }}</span
            ><br />
            已叫号：<span class="colorGreenDark">{{
              timeCacl(item.call_number_time)
            }}</span
            ><br />
            仓管员：{{ item.warehouseman }}
          </div>
        </div>
        <div class="cont3-right">
          <div>
            <van-button
              type="primary"
              class="btn"
              @click="handle('requeue', item)"
              v-if="
                privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
              "
              >重新排队</van-button
            >
          </div>
          <!-- <div>
            <van-button
              type="primary"
              class="btn btnGrey"
              @click="handle('confirmArrival', item)"
              >确认到达</van-button
            >
          </div> -->
        </div>
      </div>
      <Empty v-if="callingPassList.length == 0"></Empty>
    </div>

    <!-- 装货中 -->
    <div class="cont3" v-if="isActive === 'loading'">
      <div
        class="defaultBg mgBottom10"
        v-for="(item, index) in loadingList"
        :key="index"
        style="display: flex;"
      >
        <div class="cont3-left">
          <div class="top">{{ item.code }}</div>
          <div style="padding: 0px 10px;">
            <span class="left1">{{ item.report_info.license_plate }}</span>
            <span class="left2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            ><br />
            状态：
            <span class="colorGreenDark">{{
              loadingStateText(item.loading_state)
            }}</span
            ><br />
            单位：{{ item.report_info.unit }}<br />
            手机号码：<span class="colorBlue">{{
              item.report_info.contact
            }}</span
            ><br />
            装货计时：{{
              item.loading_time > 0 ? timeCacl(item.loading_time) : "--"
            }}<br />
            仓管员：{{ item.warehouseman }}
          </div>
        </div>
        <div class="cont3-right">
          <div
            v-if="
              item.loading_state == 1 &&
                privilegeConfig.keys &&
                privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
            "
          >
            <van-button
              type="primary"
              class="btn"
              @click="handle('startLoading', item)"
              >开始装车</van-button
            >
          </div>
          <div
            v-if="
              item.loading_state == 1 &&
                privilegeConfig.keys &&
                privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
            "
          >
            <van-button
              type="primary"
              class="btn btnPink"
              @click="handle('rejectLoading', item)"
              >拒绝装车</van-button
            >
          </div>
          <div
            v-if="
              item.loading_state == 4 &&
                privilegeConfig.keys &&
                privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
            "
          >
            <van-button
              type="primary"
              class="btn btnBlue"
              @click="handle('billed', item)"
              >已开单</van-button
            >
          </div>
          <div
            v-if="
              item.loading_state == 3 &&
                privilegeConfig.keys &&
                privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
            "
          >
            <van-button
              type="primary"
              class="btn btnOrange"
              @click="handle('completeLoading', item)"
              >装车完成</van-button
            >
          </div>
        </div>
      </div>
      <Empty v-if="loadingList.length == 0"></Empty>
    </div>
    <div
      class="cont3"
      v-if="isActive === 'loading' && loadingRejectList.length > 0"
    >
      <div class="cont3-title">已拒绝（不符合装车要求）：</div>
      <div
        class="defaultBg mgBottom10"
        v-for="(item, index) in loadingRejectList"
        :key="index"
        style="display: flex;"
      >
        <div class="cont3-left">
          <div class="top greyBg">{{ item.code }}</div>
          <div style="padding: 0px 10px;">
            <span class="left1">{{ item.report_info.license_plate }}</span>
            <span class="left2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            ><br />
            状态：{{ loadingStateText(item.loading_state) }}<br />
            单位：{{ item.report_info.unit }}<br />
            装货计时：{{
              item.loading_time > 0 ? timeCacl(item.loading_time) : "--"
            }}<br />
            <!-- <span class="left5"> -->
            仓管员：{{ item.warehouseman }}
            <!-- </span> -->
            <br />
            拒绝理由：{{ item.refused_loading_reason }}
          </div>
        </div>
        <div class="cont3-right">
          <div
            v-if="
              item.loading_state == 2 &&
                privilegeConfig.keys &&
                privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
            "
          >
            <van-button
              type="primary"
              class="btn"
              @click="handle('confirmArrival', item)"
              >重新装车</van-button
            >
          </div>
        </div>
      </div>
      <Empty v-if="loadingRejectList.length == 0"></Empty>
    </div>
    <div class="cont3" v-if="isActive === 'loading'">
      <div class="cont3-title">已结束：</div>
      <div
        class="defaultBg mgBottom10"
        v-for="(item, index) in loadingEndList"
        :key="index"
        style="display: flex;"
      >
        <div class="cont3-left">
          <div class="top greyBg">{{ item.code }}</div>
          <div style="padding: 0px 10px;">
            <span class="left1">{{ item.report_info.license_plate }}</span>
            <span class="left2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            ><br />
            状态：{{ loadingStateText(item.loading_state) }}<br />
            单位：{{ item.report_info.unit }}<br />
            手机号码：{{ item.report_info.contact }}<br />
            装货计时：{{
              Number(item.total_loading_time) > 0
                ? minNumTotext(Number(item.total_loading_time))
                : "--"
            }}<br />
            仓管员：{{ item.warehouseman }}<br />
            操作时间：{{ formatTime(item.update_time) }}
          </div>
        </div>
        <div class="cont3-right"></div>
      </div>
      <Empty v-if="loadingEndList.length == 0"></Empty>
    </div>

    <div
      style="height: 86px;background-color: #f4f5f6;"
      v-if="isActive === 'queuing'"
    ></div>
    <div
      class="footer-cont"
      v-if="
        isActive === 'queuing' &&
          privilegeConfig.keys &&
          privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-call') >= 0
      "
    >
      <van-button
        type="primary"
        block
        class="btnStyle1"
        @click="intoCallingPage"
        >叫号</van-button
      >
    </div>

    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogShow"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          <div v-if="dialogType === 'confirmArrival'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”已到达装货位置？
          </div>
          <div v-if="dialogType === 'requeue'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”重新开始排队？
          </div>
          <div v-if="dialogType === 'startLoading'">
            装车前请检查车辆<span class="colorPink">是否符合装车要求</span>，
            确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span>
            ”已准备就绪，可开始装车？
          </div>
          <div v-if="dialogType === 'completeLoading'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”已装车完成？
          </div>
          <div v-if="dialogType === 'billed'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”单据已交接？
          </div>
          <div v-if="dialogType === 'rejectLoading'">
            正在对“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span>
            ” 执行<span class="colorPink">拒绝装车</span>操作， 请输入拒绝理由：
            <van-field
              v-model="rejectReason"
              rows="3"
              :autosize="{ maxHeight: 100, minHeight: 50 }"
              type="textarea"
              placeholder="请输入拒绝理由"
              style="border: 1px solid #eee;margin-top: 8px;"
            />
          </div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="dialogShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
          <div style="flex: 1;" @click="onConfirm">
            <van-button block class="dialogBtnConfirm">确认无误</van-button>
          </div>
        </div>
      </template>
      <template #title>
        <div style="font-size: 15px;">确认提示</div>
      </template>
    </van-dialog>
    <mbComSelect></mbComSelect>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Toast } from "vant";
import moment from "moment";
import socketListStoreMixin from "@/mixins/rh/socketListStoreMixin.js";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
import socketConnetMixin from "@/mixins/rh/socketConnetMixin.js";
import Empty from "@/components/tips/Empty.vue";
import mbComSelect from "@/components/mbComSelect/index.vue";
import privilegeMixin from "@/mixins/rh/privilegeMixin.js";

export default {
  props: {},
  data() {
    return {
      socketConnetMixinRoom: "ROOM_QUEUE_WAREHOUSEMAN",
      isActive: "",
      dialogShow: false,
      dialogType: "",
      rejectReason: "", // 拒绝理由
      actionQueueId: "",
      actionQueueObj: "",
      isWarehouseman: false, // 是否班长
      queuingList: [], // 排队中
      callingList: [], // 叫号中
      callingPassList: [], // 叫号中-过号
      loadingList: [], // 装货中
      loadingRejectList: [], // 装货中-拒绝装货
      loadingEndList: [], // 装货中-结束
      lineList: [], // 产品线
      lineListActive: 0, // 当前选中的产品线
      calculationTime: null,
      calculationTimeInterval: null
    };
  },
  beforeRouteLeave(_to, _form, next) {
    try {
      window.clearInterval(this.calculationTimeInterval);
    } catch (error) {
      console.error(error);
    }
    next();
  },
  mixins: [
    socketConnetMixin,
    socketListStoreMixin,
    socketListComputedMixin,
    privilegeMixin
  ],
  watch: {
    async isJoinRoomAndMonitorEven(val) {
      if (val) {
        console.log("清空数据");
        console.log("获取业务数据");
        let proLines = await this.getProLines();
        this.lineList = proLines.data.data;
        let permission = await this.getPermission();
        permission = permission.data.data;
        // console.log(permission);
        // 班长显示排队中的业务线
        if (permission.keys.indexOf("c-car-qeue-ww-leave-call") > 0) {
          this.isWarehouseman = true;
          this.isActive = "queuing";
        } else {
          this.isWarehouseman = false;
          this.isActive = "calling";
        }
        this.getListData();
      } else {
        console.log("socket断开");
      }
    },
    evenQueueList(val) {
      console.warn("socket数据来", evenQueue);
      const evenQueue = JSON.parse(val);
      this.changeAllList(evenQueue);
    }
  },
  components: {
    mbComSelect,
    Empty
  },
  computed: {},
  async mounted() {
    this.fetchPrivilege();
  },
  methods: {
    ...mapActions(["fetchPrivilege"]),
    // 切换按钮
    changeBtn(tag) {
      this.isActive = tag;
    },

    // 操作dialog
    handle(tag, item) {
      this.dialogShow = true;
      this.dialogType = tag;
      this.actionQueueId = item.id;
      this.actionQueueObj = item;
    },

    // 确认
    async onConfirm() {
      console.log(this.dialogType);
      // confirmArrival 确认到达
      if (this.dialogType == "confirmArrival") {
        await this.$common.http({
          url: "/api/queue/warehouseman/reach_queue",
          data: {
            queue_id: this.actionQueueId
          }
        });
      }
      // requeue 重新排队
      if (this.dialogType == "requeue") {
        await this.$common.http({
          url: "/api/queue/warehouseman/again_queue",
          data: {
            queue_id: this.actionQueueId
          }
        });
      }
      // startLoading 开始装车
      if (this.dialogType == "startLoading") {
        await this.$common.http({
          url: "/api/queue/warehouseman/loading_queue",
          data: {
            queue_id: this.actionQueueId,
            state: 3
          }
        });
      }
      // rejectLoading 拒绝装车
      if (this.dialogType == "rejectLoading") {
        if (this.rejectReason.trim() === "") {
          this.$common.mbToastFail("拒绝理由不能为空");
          return false;
        }
        await this.$common.http({
          url: "/api/queue/warehouseman/loading_queue",
          data: {
            queue_id: this.actionQueueId,
            state: 2,
            refused_loading_reason: this.rejectReason
          }
        });
      }
      // completeLoading 装车完成
      if (this.dialogType == "completeLoading") {
        await this.$common.http({
          url: "/api/queue/warehouseman/loading_queue",
          data: {
            queue_id: this.actionQueueId,
            state: 4
          }
        });
      }
      // billed 已开单
      if (this.dialogType == "billed") {
        await this.$common.http({
          url: "/api/queue/warehouseman/complete_queue",
          data: {
            queue_id: this.actionQueueId
          }
        });
      }
      this.dialogShow = false;
      Toast.success("操作成功");
    },

    // 取消
    onCancel() {
      this.dialogShow = false;
    },
    // 获取权限
    getPermission() {
      return this.$common.http({
        method: "get",
        url: "/api/permission/list_mine",
        noLoading: true
      });
    },
    // 获取产品线
    getProLines() {
      return this.$common.http({
        method: "get",
        url: "/api/queue/warehouseman/query_business",
        noLoading: true
      });
    },
    // h获取排队中的数据
    getWarehousemanList() {
      if (!this.isWarehouseman) {
        return;
      }
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_loading_queue",
          data: {
            business_id:
              this.lineList.length > 0
                ? this.lineList[this.lineListActive].id
                : ""
          }
        })
        .then(res => {
          this.queuingList = [];
          this.queuingList = res.data.data;
          // this.queuingList = [{}, {}, {}, {}, {}, {}, {}, {}];
        });
    },
    // h获取查看叫号中，装货中队列
    getWcommonList(state) {
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_queue",
          data: {
            state,
            business_id:
              this.lineList.length > 0
                ? this.lineList[this.lineListActive].id
                : ""
          }
        })
        .then(res => {
          const list = res.data.data;
          if (state == 1) {
            this.callingList = [];
            this.callingPassList = [];
            list.forEach(element => {
              if (element.queue_state == 2) {
                this.callingList.push(element);
              }
              if (element.queue_state == 3) {
                this.callingPassList.push(element);
              }
            });
            // this.callingList = [{}, {}, {}, {}, {}, {}, {}, {}];
            // this.callingPassList = [{}, {}, {}, {}, {}, {}, {}, {}];
          }
          if (state == 2) {
            this.loadingList = [];
            this.loadingEndList = [];
            list.forEach(element => {
              if (
                element.loading_state == 1 ||
                element.loading_state == 3 ||
                element.loading_state == 4
              ) {
                this.loadingList.push(element);
              }
              if (element.loading_state == 2) {
                this.loadingRejectList.push(element);
              }
              if (element.loading_state == 5 || element.loading_state == 6) {
                this.loadingEndList.push(element);
              }
            });
            // this.loadingList = [{}, {}, {}, {}, {}, {}, {}, {}];
            // this.loadingEndList = [{}, {}, {}, {}, {}, {}, {}, {}];
          }
        });
    },
    // 切换产品线
    changeTab(index) {
      console.log(index);
      this.getListData();
    },
    // 获取列表数据
    getListData() {
      // this.queuingList = [];
      // this.callingList = [];
      // this.callingPassList = [];
      // this.loadingList = [];
      // this.loadingEndList = [];
      this.getWarehousemanList();
      this.getWcommonList(1);
      this.getWcommonList(2);
    },
    changeAllList({ actions, data }) {
      actions.forEach(element => {
        console.log(element, data);
        // 产品线过滤
        console.log(
          "激活产品线id:" + this.lineList[this.lineListActive].id,
          "变更数据id：" + data.business_id
        );
        if (data.business_id != this.lineList[this.lineListActive].id) {
          return;
        }
        // 排队中
        if (element.queue == "QUEUE_QUEUE") {
          console.log(
            this.queuingList[0].report_info.license_plate,
            this.queuingList
          );
          let tmpQueuingList = JSON.parse(JSON.stringify(this.queuingList));
          this.queuingList = this.reSetListBySocket(
            element.action,
            data,
            tmpQueuingList
          );
          console.log(
            this.queuingList[0].report_info.license_plate,
            this.queuingList
          );
        }
        // 叫号中-正在叫号
        if (element.queue == "QUEUE_CALLING") {
          let tmpCallingList = JSON.parse(JSON.stringify(this.callingList));
          this.callingList = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingList
          );
        }
        // 叫号中-已过号
        if (element.queue == "QUEUE_PASS_CALL") {
          let tmpCallingPassList = JSON.parse(
            JSON.stringify(this.callingPassList)
          );
          this.callingPassList = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingPassList
          );
        }
        // 队列-装车中
        if (element.queue == "QUEUE_LOADING") {
          let tmpLoadingList = JSON.parse(JSON.stringify(this.loadingList));
          this.loadingList = this.reSetListBySocket(
            element.action,
            data,
            tmpLoadingList
          );
        }
        // 队列-完成
        if (element.queue == "QUEUE_FINISH") {
          let tmpLoadingEndList = JSON.parse(
            JSON.stringify(this.loadingEndList)
          );
          this.loadingEndList = this.reSetListBySocket(
            element.action,
            data,
            tmpLoadingEndList
          );
        }
        // 队列-拒绝
        if (element.queue == "QUEUE_REFUSED_LOADING") {
          let tmploadingRejectList = JSON.parse(
            JSON.stringify(this.loadingRejectList)
          );
          this.loadingRejectList = this.reSetListBySocket(
            element.action,
            data,
            tmploadingRejectList
          );
        }
      });
    },
    // 叫号
    intoCallingPage() {
      this.$router.push({
        path: "/rhwxStoreCalling",
        query: {
          business_id: this.lineList[this.lineListActive].id
        }
      });
    }
  },
  created() {
    // window.setInterval(() => {
    //   this.$common.http({
    //     url: "/api/login_test/ws_test",
    //     data: {
    //       even: "EVENT_QUEUE_REGAIN_RANK",
    //       queue_id: "73c773b78f6a4f17bdd73ffb766df671"
    //     },
    //     noLoading: true
    //   });
    // }, 10000);
    this.calculationTime = moment();
    this.calculationTimeInterval = window.setInterval(() => {
      this.calculationTime = moment();
    }, 60000);
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.storeListDiv {
  min-height: 100vh;
  box-sizing: border-box;
  border-top: 1px solid #fff;
  background: #f4f5f6;
  .cont1 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 16px;
    background: #fff;
    margin: -1px 0px 0px;
    position: fixed;
    width: calc(100vw - 32px);
    z-index: 999;
    .blk {
      border: 1px solid #008b5e;
      display: inline-block;
      font-size: 16px;
      padding: 8px 12px;
      border-radius: 3px;
    }
    &-blk1 {
      background: #008b5e;
      color: #fff;
    }
    &-blk2 {
      color: #008b5e;
    }
  }
  // 排队中
  .cont2 {
    background: #fff;
    padding: 16px;
    margin: 10px 0px 10px;
    &-left {
      background: #f9f9fa;
      margin-bottom: 10px;
      display: flex;
      &-blk {
        display: inline-block;
        margin-right: 10px;
        width: 108px;
        // text-align: center;
        vertical-align: top;
        position: relative;
        .top {
          background: #00c8d2;
          box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
          border-radius: 4px 0 13px 0;
          // width: 55px;
          text-align: center;
          color: white;
          line-height: 23px;
          margin-bottom: 10px;
          font-size: 18px;
          min-width: 35px;
          display: inline-block;
          padding: 2px 11px;
        }
        .image {
          top: 54%;
          left: 50%;
          position: absolute;
          transform: translate(-50%, -50%);
        }
        .bottom {
          font-size: 14px;
          box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
          width: 81px;
          color: white;
          line-height: 23px;
          background: #ec3f67;
          border-radius: 0 11px 0 4px;
          position: absolute;
          text-align: center;
          bottom: 0px;
        }
      }
    }
    &-right {
      display: inline-block;
      font-size: 14px;
      line-height: 22px;
      padding: 12px 0px;
      width: calc(88vw - 120px);
      color: #4f4a4c;
      .right1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
      }
      .right2 {
        float: right;
        margin-top: 2px;
      }
      .right5 {
        float: right;
      }
    }
  }
  .font16 {
    font-size: 16px;
  }
  // 叫号中
  .cont3 {
    background: #fff;
    padding: 16px;
    margin: 10px 0px 10px;
    &-title {
      font-size: 18px;
      padding-bottom: 14px;
    }
    &-left {
      font-size: 14px;
      line-height: 22px;
      padding: 0px 0px 7px;
      flex: 2;
      color: #4f4a4c;
      .top {
        background: #00c8d2;
        box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
        border-radius: 4px 0 13px 0;
        width: 55px;
        text-align: center;
        color: white;
        font-size: 18px;
        margin-bottom: 5px;
      }
      .left1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
      }
      .left2 {
        float: right;
        margin-top: 2px;
      }
      .left5 {
        float: right;
      }
    }
    &-right {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-flow: wrap;
      padding: 21px 0px;
      & > div {
        flex: 1;
        text-align: right;
      }
    }
  }
  .defaultBg {
    background-image: linear-gradient(270deg, #fff, #f8f8f8, #f4f5f6);
  }
  .pinkBg {
    background-image: linear-gradient(270deg, #fff, #fdebef);
  }
  .greyBg {
    background: #cacaca !important;
  }
  .mgBottom10 {
    margin-bottom: 10px;
  }
  .btn {
    height: 30px !important;
    width: 81px !important;
    padding: 0px !important;
    font-size: 16px !important;
  }
  .van-dialog__message {
    font-size: 16px;
  }
  .van-dialog__header {
    opacity: 0.9;
    font-size: 16px;
    color: #000000;
    text-align: center;
  }
}
</style>
